<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow" :custom-tag="fromFooter ? 'li' : 'span'">
    <SmartLinkStandaloneElement :codename="typ.elements.label.codename" class="contact-item email-address">
      <span>
        <font-awesome class="contact-icon fa-fw" icon="at" v-if="data.showIcon" />
      </span>

      <span v-if="data.label" class="contact-label">{{ data.label}}</span>

      <span>
        <a class="contact-link" :href="`mailto:${data.emailAddress}`">{{ data.emailAddress }}</a>
      </span>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import type { IContentItem } from '@kontent-ai/delivery-sdk'
import type { ContactItemEmailModel } from '~/models'
import { contentTypes } from '~/models'
const typ = contentTypes._contact_item___email___

const props = defineProps<{ model: IContentItem, fromFooter: boolean }>()
const model = props.model as ContactItemEmailModel
const data = {
  label: model.elements.label.value,
  emailAddress: model.elements.emailAddress.value,
  showIcon: multipleChoiceToBoolean(model.elements.showIcon)
}
</script>
